// @flow

import * as React from 'react';
import styles from './SectionTitle.less';

/** Title of a section in the footer */
const SectionTitle = ({ text }: { text: string }) => (
  <div className={styles.sectionHeader}>{text}</div>
);

export default SectionTitle;
